import type { ReactNode } from 'react';
import { PublicLayout } from '../../components/layout/PublicLayout';
import type { PublicPageSeo } from './seoConfig';
import { usePublicPageSeo } from './usePublicPageSeo';
import { startGoogleSignIn } from './site';

export function PublicContentPage({
  seo,
  children,
}: {
  seo: PublicPageSeo;
  children: ReactNode;
}) {
  usePublicPageSeo(seo);

  return (
    <PublicLayout onSignIn={() => startGoogleSignIn()}>
      <article className="mx-auto max-w-app px-4 py-10 sm:py-14">{children}</article>
    </PublicLayout>
  );
}

export function publicPageHeading(title: string, description: string) {
  return (
    <header className="mb-10 space-y-3 text-center sm:text-left">
      <h1 className="text-2xl font-bold tracking-tight sm:text-3xl">{title}</h1>
      <p className="max-w-2xl text-base leading-relaxed text-muted">{description}</p>
    </header>
  );
}
